/** Everyone's roster, with points and Tera Captains (which you can change for your own) */
import { getPoints, getPointsUsed } from '@ogreclan/league-core';
import type { LeagueProps } from '../pages/league';
import { Mon } from '../pokemon';
import { ActionButton } from '../ui';

export function RostersTab({ view, data, act }: LeagueProps) {
	const { league } = view;
	const { settings } = league;
	// captains can change before the season, and during it (changing them mid-season is up to room staff on Showdown)
	const captainsOpen = settings.tera && league.phase !== 'ended';
	return <div class="grid">
		{league.players.map(player => {
			const mine = player.id === view.you;
			const canEdit = captainsOpen && (mine || view.role === 'staff');
			return <div key={player.id} class="card" style={mine ? 'outline:2px solid var(--accent)' : ''}>
				<div class="row" style="justify-content:space-between">
					<h3 style="margin:0">{player.name}</h3>
					{settings.type === 'points' && <span class="muted small">{getPointsUsed(league, player)}/{settings.budget} points</span>}
				</div>
				<p class="muted small" style="margin:2px 0 0">{player.roster.length}/{settings.picks} Pokémon
					{settings.tera && <> · {player.captains.length}/{settings.teraCaptains} Tera Captains</>}
					{player.owedPicks > 0 && <> · <span class="badge warn">owed {player.owedPicks}</span></>}</p>
				<ul class="roster">
					{player.roster.map(id => {
						const captain = player.captains.includes(id);
						return <li key={id}>
							<Mon data={data} id={id} types stacked />
							{captain && <span class="star" title="Tera Captain">★</span>}
							<span class="pts">{settings.type === 'points' ? `${getPoints(league, id)} pts` : ''}</span>
							{canEdit && <ActionButton class="small" title={captain ? 'Stop it being a Tera Captain' : 'Make it a Tera Captain'}
								action={() => act('captain', mine ? id : `${id}, ${player.id}`)}>{captain ? 'Uncaptain' : 'Captain'}</ActionButton>}
						</li>;
					})}
					{!player.roster.length && <li class="empty">No Pokémon yet.</li>}
				</ul>
			</div>;
		})}
		{!league.players.length && <p class="empty">No players yet.</p>}
	</div>;
}
